<div class="lang mr33">
    <div class="pointer" [ngClass]="{'active': lang == 'en'}" (click)="setLang('en')">EN</div>
    <div class="pointer" [ngClass]="{'active': lang == 'zh-HK'}" (click)="setLang('zh')">繁體中文</div>
</div>
